window.APP.IMAGES.favIconUrl = window.APP.EXTERNAL_LINKS.Images.favIconUrl;
window.APP.IMAGES.OrgUnitsIcon = require('../images/VC_VCM_Icons_v2_Organisational_Units.svg');
window.APP.IMAGES.GroupsIcon = require('../images/VC_VCM_Assets_FA_Groups.svg');
window.APP.IMAGES.UserIcon = require('../images/usericon.svg');
window.APP.IMAGES.UserIconBlue = require('../images/usericonblue.svg');
window.APP.IMAGES.HelpIconColor = require('../images/Icon_Help.svg');
window.APP.IMAGES.HelpIcon = require('../images/helpicon.svg');
window.APP.IMAGES.HelpIconHover = require('../images/helpiconhover.svg');
window.APP.IMAGES.WaitingAreaIcon = require('../images/VC_VCM_Icons_v2_Waiting_Areas.svg');
window.APP.IMAGES.MeetingRoomIcon = require('../images/VC_VCM_Icons_v2_Meeting_Rooms.svg');
window.APP.IMAGES.UserManagementPageIcon = require('../images/HDA_VC_VCM_Icons_2018_User_Management.svg');
window.APP.IMAGES.UserManagementOrgPageIcon = require('../images/HDA_VC_VCM_Icons_2018_Org_User_Management.svg');
window.APP.IMAGES.ReportPageIcon = require('../images/VC_VCM_Icons_v2_Reports.svg');
window.APP.IMAGES.TagWaitingAreaIcon = require('../images/VC_VCM_Icons_v2_Tag_Waiting_Area .svg');
window.APP.IMAGES.TagOrgUnitIcon = require('../images/VC_VCM_Icons_v2_Tag_Org_Units.svg');
window.APP.IMAGES.UmbrellaLogo = window.APP.EXTERNAL_LINKS.Images.UmbrellaLogo;
window.APP.IMAGES.SmallUmbrellaLogo = window.APP.EXTERNAL_LINKS.Images.SmallUmbrellaLogo;
window.APP.IMAGES.UmbrellaMasterLogo = window.APP.EXTERNAL_LINKS.Images.UmbrellaMasterLogo;
window.APP.IMAGES.ApplicationLogo = window.APP.EXTERNAL_LINKS.Images.ApplicationLogo;
window.APP.IMAGES.PlatformLogo = window.APP.EXTERNAL_LINKS.Images.PlatformLogo;
window.APP.IMAGES.FooterLogoImg = window.APP.EXTERNAL_LINKS.Login.FooterImgSplashLogo;
window.APP.IMAGES.InfoIcon = require('../images/VC_VCM_Assets_FA_Info.svg');
window.APP.IMAGES.UsersIcon = require('../images/VC_VCM_Assets_FA_Users1.svg');
window.APP.IMAGES.UsersIconBlue = require('../images/VC_VCM_Assets_FA_Users2.svg');
window.APP.IMAGES.HomeIcon = require('../images/VC_VCM_Home_Icon_FA.svg');
window.APP.IMAGES.ProfilePlaceholder = require('../images/profile-placeholder.png');
window.APP.AUDIO.NewRoomInWaitingAreas = require('../audio/remote_caller_add.wav');
window.APP.IMAGES.SubscriptionPlan = require('../images/FeatureCompare.svg');
window.APP.IMAGES.GCWaitingAreaIcon = require('../images/icon_gc_wa.svg');

let sheet = (function () {
  var style = document.createElement('style');

  style.appendChild(document.createTextNode(''));

  document.body.appendChild(style);

  return style.sheet;
})();

function addCSSRule(sheet, selector, rules, index) {
  if ('insertRule' in sheet) {
    sheet.insertRule(selector + '{' + rules + '}', index);
  } else if ('addRule' in sheet) {
    sheet.addRule(selector, rules, index);
  }
}

addCSSRule(
  sheet,
  'i.icon.user:before',
  'content:url(' + window.APP.IMAGES.UserIcon.default + '); fill:currentColor;',
  0
);
addCSSRule(
  sheet,
  'i.icon.user.blue:before',
  'content:url(' + window.APP.IMAGES.UserIconBlue.default + '); fill:currentColor;',
  0
);
addCSSRule(
  sheet,
  'i.icon.help:before',
  'content:url(' + window.APP.IMAGES.HelpIcon.default + '); fill:currentColor;',
  1
);
addCSSRule(
  sheet,
  'i.icon.help:before',
  'content:url(' + window.APP.IMAGES.HelpIconHover.default + '); fill:currentColor;',
  2
);
addCSSRule(sheet, 'i.icon.help.circle:before', 'content:url(' + window.APP.IMAGES.HelpIcon.default + ')', 3);
addCSSRule(sheet, 'i.icon.help.circle:hover:before', 'content:url(' + window.APP.IMAGES.HelpIconHover.default + ')', 4);
addCSSRule(sheet, 'i.icon.ui.circle.info:before', 'content:url(' + window.APP.IMAGES.InfoIcon.default + ')', 5);
addCSSRule(
  sheet,
  'i.icon.users.color-neutral-center-gray:before',
  'content:url(' + window.APP.IMAGES.UsersIcon.default + ')',
  6
);
addCSSRule(
  sheet,
  'i.icon.users.color-meeting-room:before',
  'content:url(' + window.APP.IMAGES.UsersIconBlue.default + ')',
  7
);
addCSSRule(
  sheet,
  'i.icon.users.color-meeting-room:before',
  'content:url(' + window.APP.IMAGES.UsersIconBlue.default + ')',
  7
);
addCSSRule(sheet, 'i.icon.home:before', 'content:url(' + window.APP.IMAGES.HomeIcon.default + ')', 7);
